import { useRef, useCallback } from 'react';

export default function Card3D({
  children,
  className = '',
  style,
  intensity = 9,
  lift = 16,
  tilt = true,
}) {
  const cardRef = useRef(null);
  const glareRef = useRef(null);
  const rafRef = useRef(0);

  const handleMove = useCallback(
    (e) => {
      if (!tilt) return;
      const el = cardRef.current;
      if (!el) return;

      const { clientX, clientY } = e;

      cancelAnimationFrame(rafRef.current);
      rafRef.current = requestAnimationFrame(() => {
        const rect = el.getBoundingClientRect();
        const px = (clientX - rect.left) / rect.width;
        const py = (clientY - rect.top) / rect.height;

        const rotateX = (0.5 - py) * intensity * 2;
        const rotateY = (px - 0.5) * intensity * 2;

        el.style.transform =
          `perspective(1000px) rotateX(${rotateX.toFixed(2)}deg) ` +
          `rotateY(${rotateY.toFixed(2)}deg) translateZ(${lift}px) scale(1.015)`;

        el.style.boxShadow =
          `${(-rotateY * 1.6).toFixed(1)}px ${(rotateX * 1.6 + 18).toFixed(1)}px ` +
          `38px -6px var(--nad-card-shadow)`;

        if (glareRef.current) {
          glareRef.current.style.opacity = '1';
          glareRef.current.style.background =
            `radial-gradient(circle at ${(px * 100).toFixed(1)}% ${(py * 100).toFixed(1)}%, ` +
            `var(--nad-card-glare), transparent 55%)`;
        }
      });
    },
    [intensity, lift, tilt]
  );

  const handleLeave = useCallback(() => {
    cancelAnimationFrame(rafRef.current);
    const el = cardRef.current;
    if (!el) return;

    el.style.transform =
      'perspective(1000px) rotateX(0deg) rotateY(0deg) translateZ(0px) scale(1)';
    el.style.boxShadow = '';

    if (glareRef.current) glareRef.current.style.opacity = '0';
  }, []);

  return (
    <div
      ref={cardRef}
      onMouseMove={tilt ? handleMove : undefined}
      onMouseLeave={tilt ? handleLeave : undefined}
      className={`card-3d ${className}`}
      style={style}
    >
      {tilt && <div ref={glareRef} className="card-3d-glare" />}
      <div className="card-3d-content w-full h-full">{children}</div>
    </div>
  );
}
